import { FormikProps } from 'formik';
import React from 'react';
import Tooltip from '@cpg-its/ads.common.tooltip';
import { FormField } from '../../../../../global/components/form-element/form-field';
import { DividerSection } from '../../../../../global/components/layout/divider-section';
import { PensionEnrollmentProps } from '../../../models/arc-epi-props';
import { PensionEnrollmentFormValues } from '../models/pension-enrollment-form-model';
import { PensionEnrollmentContributionType, PensionEnrollmentPlan, PensionEnrollmentPlanType } from '../models/pension-enrollment-model';
import { NumberField, NumberInputTypes } from '../../../../../global/components/form-element/number-field';
import { FormGroup } from '../../../../../global/components/layout/form-group';
import { tcsmColors } from '../../../../../global/constants/theme/theme-constants/colors';
import { labelSupplementStyles } from '../../../../../global/constants/theme/styles/components/label-supplement-styles';

interface Props {
    pensionEnrollmentProps: PensionEnrollmentProps;
    selectedPlan: PensionEnrollmentPlan;
    formProps: FormikProps<PensionEnrollmentFormValues>;
}

export function PensionEnrollmentEmployeeContribution(props: Props) {

    const { pensionEnrollmentProps, selectedPlan, formProps } = props;
    const labelClasses = labelSupplementStyles();
    const contributionTypeOptions = [
        {
            label: pensionEnrollmentProps?.byPercentageOptionText || 'By Percentage',
            value: PensionEnrollmentContributionType.Percentage,
        },
        {
            label: pensionEnrollmentProps?.byFixedAmountOptionText || 'By Fixed Amount',
            value: PensionEnrollmentContributionType.FixedAmount,
        },
    ];

    // only show for rsvp and dc plans
    if (selectedPlan?.plan_type !== PensionEnrollmentPlanType.RsvpPlan && selectedPlan?.plan_type !== PensionEnrollmentPlanType.DcPlan) return null;

    return (
        <DividerSection sectionText={pensionEnrollmentProps?.employeeContributionsHeader} topDivider>
            <div className={`${labelClasses.labelLayout} divider-section-item-header`}>
                <h3>{pensionEnrollmentProps?.employeeContributionsSubHeader}</h3>
                <div className='supplement-wrapper'>
                    <Tooltip iconColor={tcsmColors.blue} title={pensionEnrollmentProps?.employeeContributionsTooltip} />
                </div>
            </div>
            <p>{pensionEnrollmentProps?.employeeContributionsDescription}</p>
            <FormGroup>
                <FormField
                    name='contribution_type'
                    component='radioGroup'
                    options={contributionTypeOptions}
                    touched={formProps.touched}
                    errors={formProps.errors}
                    required
                />

                <NumberField
                    type={formProps.values.contribution_type === PensionEnrollmentContributionType.Percentage
                        ? NumberInputTypes.Percentage
                        : NumberInputTypes.Currency}
                    name='contribution_amount'
                    label={pensionEnrollmentProps?.preTaxContributionLabel}
                    formikProps={formProps}
                    disabled={!formProps.values.contribution_type}
                    autoWidth
                    required
                />
            </FormGroup>
        </DividerSection>
    );
}